<template>
  <q-dialog v-model="dialogChannel" persistent>
    <q-card style="min-width: 600px">
      <q-toolbar class="bg-primary text-white">
        <q-toolbar-title> {{ $t('channel_information') }}</q-toolbar-title>
        <q-btn flat round dense icon="mdi-close" @click="onClose" />
      </q-toolbar>
      <q-form @submit="onSave">
        <q-card-section class="scroll" style="max-height: 70vh">
          <div class="row q-col-gutter-md">
            <div class="col-9">
              <q-select
                v-model="form.site_type_id"
                use-input
                input-debounce="200"
                @filter="filterSiteType"
                :options="siteTipsFiltered"
                outlined
                label="Vertical"
                option-label="site_type"
                option-value="id"
                clear-icon="mdi-close"
                clearable
                lazy-rules
                :rules="[isRequired]"
              />
            </div>
            <div class="col-3">
              <q-input outlined v-model="form.cj_id" type="text" label="CJ ID" maxlength="20" />
            </div>
          </div>
          <div class="col-12">
            <q-input outlined v-model="form.name" type="text" :label="$t('name')" lazy-rules :rules="[isRequired]" />
          </div>

          <div class="col-12">
            <q-select
              v-model="form.category"
              use-input
              input-debounce="200"
              @filter="filterSiteCategory"
              :options="siteCategoryFiltered"
              :label="$t('site_category')"
              option-label="name"
              option-value="id"
              outlined
              lazy-rules
              :rules="[isRequired]"
            />
          </div>
          <div class="col-12">
            <q-input
              outlined
              type="textarea"
              :label="'Url '+ ' ' + this.$t('of_2') + ' ' + this.$t('channel')"
              v-model="form.url"
              lazy-rules
              :rules="[isRequired]"
            />
          </div>
          <div class="col-12">
            <q-input
              outlined
              type="textarea"
              :label="$t('description')"
              v-model="form.description"
              lazy-rules
              :rules="[isRequired]"
            />
          </div>
          <template v-if="isPicpayAffiliate">
            <div class="col-12 col-md-6">
              <q-input
                outlined
                label="Frequência (MHz)"
                type="number"
                step="0.1"
                min="87.5"
                max="108"
                v-model.number="form.dial"
                lazy-rules
                :rules="[validDial]"
                hint="Ex.: 95.1, 102.1 — faixa FM (87,5 a 108 MHz)"
              />
            </div>
            <div class="col-12 col-md-6">
              <q-select
                v-model="form.region"
                :options="regions"
                label="Região"
                outlined
                clear-icon="mdi-close"
                clearable
                lazy-rules
                :rules="[isRequired]"
              />
            </div>
            <div class="col-12 col-md-12">
              <q-select
                v-model="form.frequencyType"
                :options="frequencyTypes"
                label="Tipo de frequência"
                outlined
                clear-icon="mdi-close"
                clearable
                lazy-rules
                :rules="[isRequired]"
              />
            </div>
          </template>
        </q-card-section>
        <q-separator />
        <q-card-actions align="right" class="q-pa-md">
          <q-btn outline :label="$t('cancel')" no-caps padding="sm lg" color="primary" @click="onClose" />
          <q-btn unelevated :label="$t('update_information')" no-caps padding="sm lg" color="primary" type="submit" />
        </q-card-actions>
      </q-form>
    </q-card>
  </q-dialog>
</template>

<script>
import ChannelMixin from '../../mixins/ChannelMixin';
import AffiliateService from '../../services/AffiliateService';
import AdvertiserService from '../../services/AdvertiserService';

export default {
  name: 'FormChannel',
  mixins: [ChannelMixin, AffiliateService, AdvertiserService],
  data() {
    return {
      form: {
        name: null,
        category: null,
        description: null,
        site_type_id: null,
        id: null,
        url: null,
        cj_id: null,
        dial: null,
        region: null,
        frequencyType: null
      },
      roles: [],
      loading_role: false,
      loading_profile: false,
      profiles: [],
      siteTips: [],
      siteTipsFiltered: [],
      siteCategory: [],
      siteCategoryFiltered: [],
      regions: ['Norte', 'Sul', 'Centro-Oeste', 'Sudeste', 'Nordeste'],
      frequencyTypes: ['AM', 'FM'],
      refererAdvertiserForPicpay: null,
      refererAdvertiserLoadSeq: 0
    };
  },
  computed: {
    isPicpayAffiliate() {
      const ch = this.channelSelect;
      if (!ch) return false;

      const isAdvertiserReferer =
        ch.referer_id != null &&
        ch.referer_id !== '' &&
        String(ch.referer_type || '').toLowerCase() === 'advertiser';

      if (isAdvertiserReferer) {
        const key = this.refererAdvertiserForPicpay && this.refererAdvertiserForPicpay.referer_key;
        return String(key || '').toLowerCase() === 'picpay';
      }

      const refererKey = ch.referer_key || '';
      return String(refererKey).toLowerCase() === 'picpay';
    }
  },
  methods: {
    async syncRefererAdvertiserForPicpay() {
      const ch = this.channelSelect;
      if (!ch) {
        this.refererAdvertiserForPicpay = null;
        return;
      }

      const needsAdvertiser =
        ch.referer_id != null &&
        ch.referer_id !== '' &&
        String(ch.referer_type || '').toLowerCase() === 'advertiser';

      if (!needsAdvertiser) {
        this.refererAdvertiserForPicpay = null;
        return;
      }

      const seq = ++this.refererAdvertiserLoadSeq;
      try {
        this.onLoading(true);
        const { data, status } = await this.getAdvertiserById(ch.referer_id);
        if (seq !== this.refererAdvertiserLoadSeq) return;
        this.refererAdvertiserForPicpay = status === 200 ? data : null;
      } catch (e) {
        if (seq !== this.refererAdvertiserLoadSeq) return;
        this.refererAdvertiserForPicpay = null;
      } finally {
        this.onLoading(false);
      }
    },

    parseDial(dial) {
      if (dial == null || dial === '') return null;
      const n = typeof dial === 'number' ? dial : parseFloat(String(dial).replace(',', '.'));
      if (!Number.isFinite(n)) return null;
      return Math.round(n * 10) / 10;
    },

    validDial(v) {
      if (v === null || v === undefined || v === '') {
        return 'Informe a frequência em MHz (ex.: 95.1)';
      }
      const n = this.parseDial(v);
      if (n === null) return 'Use um número válido (ex.: 95.1)';
      if (n < 87.5 || n > 108) return 'Informe uma frequência entre 87,5 e 108 MHz';
      return true;
    },

    filterSiteType(val, update) {
      update(() => {
        const needle = val.toLocaleLowerCase();
        if (!needle) this.siteTipsFiltered = this.siteTips;
        this.siteTipsFiltered = this.siteTips.filter((v) => v.site_type.toLocaleLowerCase().indexOf(needle) > -1);
      });
    },

    filterSiteCategory(val, update) {
      update(() => {
        const needle = val.toLocaleLowerCase();
        if (!needle) this.siteCategoryFiltered = this.siteCategory;
        this.siteCategoryFiltered = this.siteCategory.filter((v) => v.name.toLocaleLowerCase().indexOf(needle) > -1);
      });
    },

    onClose() {
      this.ActionSetDialogChannel(false);
    },
    async onSave() {
      this.onLoading(true);

      try {
        let formEdit = { ...this.form };
        formEdit.site_type_id = this.form.site_type_id.id;
        formEdit.category = this.form.category.id;

        delete formEdit.id;
        delete formEdit.frequencyType;

        if (this.isPicpayAffiliate) {
          formEdit.dial = this.parseDial(this.form.dial);
          formEdit.region = this.form.region;
          formEdit.frequency_type = this.form.frequencyType;
        } else {
          delete formEdit.dial;
          delete formEdit.region;
          delete formEdit.frequency_type;
        }

        const { status } = await this.editAffiliateChannel(this.channelSelect.id, formEdit);
        if (status === 200 || status === 201) {
          this.successNotify(this.$t('channel_updated_successfully'));
        }
      } catch (error) {
        if (error.response.data.errors !== undefined)
          Object.keys(error.response.data.errors).forEach((key) => {
            this.errorNotify(error.response.data.errors[key]);
          });
      } finally {
        await this.onSetup();

        this.onLoading(false);
      }
    },
    async getSiteTips() {
      try {
        const { data, status } = await this.getAffiliateSiteTips();
        if (status === 200 || status === 201) {
          this.siteTips = data;
          this.siteTipsFiltered = data;
        }
      } catch (error) {
        if (error.response && error.response.status === 500)
          this.errorNotify(this.$t('problem_try_again_later'));
        else this.errorNotify(error);
      }
    },
    async getSitesCategory() {
      try {
        const { data, status } = await this.getAffiliateSiteCategoryFilter();
        if (status === 200 || status === 201) {
          this.siteCategory = data;
          this.siteCategoryFiltered = data;
        }
      } catch (error) {
        if (error.response && error.response.status === 500)
          this.errorNotify(this.$t('problem_try_again_later'));
        else this.errorNotify(error);
      }
    },
    async onSetup() {
      this.onLoading(true);

      await this.syncRefererAdvertiserForPicpay();
      await this.getSiteTips();
      await this.getSitesCategory();

      try {
        const { data, status } = await this.getAffiliateSiteData(this.channelSelect.id);
        if (status === 200 || status === 201) {
          this.form = { ...data };

          this.form.site_type_id = this.siteTips.find((item) => item.id === parseInt(data.site_type_id));
          this.form.category = this.siteCategory.find((item) => item.id === parseInt(data.category));

          const frequencyRaw =
            data.frequency_type != null && data.frequency_type !== '' ? data.frequency_type :data.frequencyType;
          this.form.dial = this.parseDial(data.dial);
          this.form.region = data.region != null && data.region !== '' ? data.region : null;
          this.form.frequencyType =
            frequencyRaw != null && frequencyRaw !== '' ? frequencyRaw : null;
        }
      } catch (error) {
        if (error.response && error.response.status === 500)
          this.errorNotify(this.$t('problem_try_again_later'));
        else this.errorNotify(error);
      } finally {
        this.onLoading(false);
      }
    }
  },
  watch: {
    channelSelect() {
      if (this.channelSelect !== null) {
        this.onSetup();
      } else {
        this.refererAdvertiserForPicpay = null;
      }
    }
  }
};
</script>

<style></style>
